{ trackSeparator } = require 'app/scripts/views/card/SeparatorCard/SeparatorCard'
{ getKey, Key } = require '@trello/keybindings'
Util = require 'app/scripts/lib/util'
removeAllRanges = require 'app/scripts/lib/util/removeAllRanges'
Controller = require 'app/scripts/controller'
l = require 'app/scripts/lib/localize'

module.exports.saveCardName = ->
  $input = @$('.js-card-detail-title-input')
  newValue = $input.val()
  name = @model.get('name')

  # remove whitespace
  newValue = newValue.replace(/\s+/g, ' ').trim()

  # if it's the same name, don't save
  if newValue == name
    return

  # if it's too long, don't save
  if newValue.length > 16384
    return

  # can't be empty.
  if newValue.trim().length == 0
    return

  # We should handle the returned `err` someday…
  @model.update 'name', newValue

  trackSeparator(newValue, {
    category: 'card detail'
    method: 'by editing name'
  })

  return

module.exports.nameKeyDownEvent = (e) ->

  if getKey(e) == Key.Enter
    Util.stop(e) # prevents new lines
    @saveNameEditing()

  if getKey(e) == Key.Escape
    Util.stop(e) # don't close the overlay…
    @cancelNameEditing()

  return

module.exports.startNameEditing = (options = {}) ->
  $input = @$('.js-card-detail-title-input')

  if !$input.hasClass('is-editing')
    $input.addClass('is-editing')

    if options.focus
      $input.focus().select()

  return

module.exports.saveNameEditing = ->
  $input = @$('.js-card-detail-title-input')
  if $input.hasClass('is-editing')
    @stopNameEditing()
    @saveCardName()

module.exports.cancelNameEditing = ->
  @stopNameEditing()
  @renderName()

module.exports.stopNameEditing = ->
  $input = @$('.js-card-detail-title-input')
  if $input.hasClass('is-editing') && $input.val().trim()
    $input.removeClass('is-editing')
    # We previously only blurred the $input if it looked like it had focus,
    # but this was problematic.
    #
    # If you switch tabs in Chrome by clicking on another tab and then come
    # back to this window, jquery will fire a `focusout` event, and we'd
    # end up in a state where the input still looked active even though
    # the edit had finished.
    $input.blur()
    removeAllRanges()

  return

module.exports.renderName = ->
  cardName = @model.get('name')
  boardName = @model.getBoard().get('name')

  # Hidden helper for accessibility and printing.
  @$('.js-title-helper').text(cardName)

  # Don't try and rerender while we're editing, we'll lose edits. Last
  # writer wins here.
  # We need to trigger a resize because the textarea won't resize for the
  # non-editing viewer.
  $input = @$('.js-card-detail-title-input')
  if !$input.hasClass('is-editing')
    $input.val(cardName).trigger('autosize.resize', false)

  # Controller.title needs a *string*, not HTML
  Controller.title(l('card detail title', { cardName, boardName }, { raw: true }))
  @

module.exports.editTitle = (e) ->
  @startNameEditing({ focus: true })
  return
